import data from "../../../configs/data";
import {Button} from "../../../controlElements/Button";
import {ObservableContainer} from "../../../controlElements/ObservableContainer";
import {DeviceDetector} from "../../../DeviceDetector";

export class ColumnBetsPanel extends ObservableContainer {

    private buttons: Array<Button> = [];

    private readonly POSSIBLE_COLUMN_BETS: Array<Array<number>> = [
        [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34],
        [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
        [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36],
    ];

    constructor(straightBetsButtonsOffsetX: number,
                straightBetsButtonsOffsetY: number,
                straightBetsOffsetFromZero: number) {
        super();
        this.createAndAddBetsButtons(
            straightBetsButtonsOffsetX,
            straightBetsButtonsOffsetY,
            straightBetsOffsetFromZero);
    }

    public getButtonPosition(number: number): PIXI.Point {
        return (this.buttons[number].position as PIXI.Point);
    }

    private createAndAddBetsButtons(straightBetsButtonsOffsetX: number, straightBetsButtonsOffsetY: number,
                                    straightBetsOffsetFromZero: number): void {
        for (let index = 0;
             index < 3; index++) {
            const row = 2 - (index % 3);
            const button = new Button(data.images.columnBaseState, data.images.columnHoverDisableState,
                data.images.columnHoverDisableState, data.images.columnHoverDisableState);

            this.initializeBetButtonBehavior(button, index);
            button.position.x = straightBetsOffsetFromZero + straightBetsButtonsOffsetX * 12;
            button.position.y = row * straightBetsButtonsOffsetY;
            this.buttons.push(button);
            this.addChild(button);
        }
    }

    private onValueChosen(index: number): void {
        this.callOnClickedSubscribers(index, this.POSSIBLE_COLUMN_BETS[index]);
    }

    private onHover(index: number): void {
        this.callOnPointerDownSubscribers(index, this.POSSIBLE_COLUMN_BETS[index]);
    }

    private onHoverOutside(index: number): void {
        this.callOnPointerUpSubscribers(index, this.POSSIBLE_COLUMN_BETS[index]);
    }

    private initializeBetButtonBehavior(button: Button, thisArg: any): void {
        button.subscribeOnClicked(this.onValueChosen.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_DOWN, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_CANCEL, this.onHoverOutside.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OVER, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OUT, this.onHoverOutside.bind(this, thisArg));
        if (DeviceDetector.isMobileOrTabletDevice()) {
            button.on(Button.BUTTON_EVENTS.POINTER_UP, this.onHoverOutside.bind(this, thisArg));
            button.on(Button.BUTTON_EVENTS.POINTER_UP_OUTSIDE, this.onHoverOutside.bind(this, thisArg));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/rouletteBetsPanel/implementations/ColumnBetsPanel.ts